module.exports = __webpack_public_path__ + "img/fully_enclosed_and_attached_to_main_house_with_independent_roof.1bc8c5a2.jpg";